import React from 'react';
import Checkbox from 'housecall-ui/dist/DesignSystem/Inputs/Checkboxes/Checkbox'
import {Field} from 'redux-form';

const FormCheckbox = ({ ...restProps }) => {
    return (
        <Field component={renderCheckbox} {...restProps}/>
    )
}

const renderCheckbox = ({input, value, checked, meta: {touched, error}, ...custom}) => {
    return  <Checkbox
        color='primary'
        value={value}
        checked={input.value}
        onChange={(event, checked) => input.onChange(checked)}
        {...custom}
    />
}

export default FormCheckbox
